module.exports = __webpack_public_path__ + "static/media/IEEES12-1.4a1f393c.jpg";